import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders,
  HttpEventType,
} from "@angular/common/http";
import { Observable, tap } from "rxjs";
import { AuthenticationService } from "../../../services/authentication.service";
// import { environment } from "../../../environments/environment";
import { CookieService } from "ngx-cookie-service";

// import { AutologoutService } from 'src/services/member/autologout.service';

const AUTH_ERROR_CODES = new Set([
  "authentication_failed",
  "not_authenticated",
  "authentication_expired",
  "invalid_user",
  "invalid_token",
]);

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  currentTwofaToken: any;
  bearerData: any;
  constructor(private authenticationService: AuthenticationService , private cookies: CookieService) {}

  private parseErrorBody(error: unknown): { error?: { code?: string } } | null {
    if (error == null) return null;
    if (typeof error === "string") {
      try {
        return JSON.parse(error);
      } catch {
        return null;
      }
    }
    if (typeof error === "object") {
      return error as { error?: { code?: string } };
    }
    return null;
  }

  private isAuthErrorPayload(payload: unknown): boolean {
    const code = this.parseErrorBody(payload)?.error?.code;
    return code !== undefined && AUTH_ERROR_CODES.has(code);
  }

  private handleSessionExpired(): void {
    this.cookies.deleteAll();
    localStorage.clear();
    document.dispatchEvent(new Event("Login.sessionExpired"));
  }

  private isStreamingRequest(request: HttpRequest<any>): boolean {
    return (
      request.responseType === "text" &&
      (request.url.includes("/stream/") || request.url.includes("/generate/"))
    );
  }

  private isAuthErrorInStreamBody(body: string | null | undefined): boolean {
    const trimmed = body?.trim();
    if (!trimmed || trimmed.startsWith("event:")) {
      return false;
    }
    return this.isAuthErrorPayload(trimmed);
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    // add authorization header with bearer token if available
    let currentUser = this.authenticationService.currentUserValue;
    if (currentUser && currentUser.access_token) {
      // change this to currentUser.access_token once current user is cleared from local storage when the token expires
      request = request.clone({
        setHeaders: {
          Authorization:
            "Bearer " +
            (currentUser.access_token ? currentUser.access_token : ""),
        },
      });

      if (
        request.url.includes("generate-email-otp/") ||
        request.url.includes("verify-email-otp/") ||
        request.url.includes("generate-2fa-qr/") ||
        request.url.includes("setup-2fa/") ||
        request.url.includes("verify-totp/")
      ) {
        this.currentTwofaToken = localStorage.getItem("for_2fa_only");
        request = request.clone({
          headers: new HttpHeaders({
            "Two-FA-Token": this.currentTwofaToken,
          }),
        });
      }
    } else {
      let setHeaders: any = {};
      request = request.clone({ setHeaders: setHeaders });

      if (request.url.includes("/auth/2fa/login/")) {

        this.bearerData = JSON.parse(localStorage.getItem("bearerData") || "");
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${this.bearerData.two_fa_token}`,
          },
        });
      }
      if (request.url.includes("auth/2fa/verify-setup/")) {
        this.bearerData = JSON.parse(localStorage.getItem("bearerData") || "");
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${this.bearerData.two_fa_token}`,
          },
        });
      }
    }
    return next.handle(request).pipe(
      tap({
        next: (event: HttpEvent<any>) => {
          if (!this.isStreamingRequest(request)) {
            return;
          }
          if (event.type === HttpEventType.Response) {
            if (this.isAuthErrorInStreamBody(event.body)) {
              this.handleSessionExpired();
            }
          } else if (event.type === HttpEventType.DownloadProgress) {
            const partial = (event as { partialText?: string }).partialText;
            if (this.isAuthErrorInStreamBody(partial)) {
              this.handleSessionExpired();
            }
          }
        },
        error: (err: any) => {
          if (this.isAuthErrorPayload(err?.error)) {
            this.handleSessionExpired();
          }
        },
      }),
    );
  }
}
